import { render, staticRenderFns } from "./FacetChart.vue?vue&type=template&id=35ac8b88&"
import script from "./FacetChart.vue?vue&type=script&lang=js&"
export * from "./FacetChart.vue?vue&type=script&lang=js&"
import style0 from "./FacetChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports